<div class="flex flex-col h-full">
	<div class="flex-1 overflow-auto">
		<app-matter-url-pdf-viewer
			*ngIf="googleSrcUrl"
			[googleSrcUrl]="googleSrcUrl"
			[base64Encoded]="base64Encoded"
			[content]="url"
			[fileName]="fileName"
			[fileType]="fileType"
			[showDelete]="showDelete"
			[showMultiple]="true"
			(delete)="delete()"
			(closeModal)="close()"
		></app-matter-url-pdf-viewer>
	</div>

	<div class="line-break my-4"></div>

	<div>
		<div class="flex justify-between">
			<app-button size="small" btn="clear" (onClick)="close()"
				>Close</app-button
			>

			<div class="flex gap-x-4">
				<app-button
					*ngIf="!viewOnly"
					size="small"
					btn="error"
					(onClick)="flagReport()"
					[loading]="isFlagging"
					>Flag</app-button
				>

				<app-button
					size="small"
					[loading]="isVerifying"
					(onClick)="verifyReport()"
					>Verify
				</app-button>
			</div>
		</div>
	</div>
</div>
